import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import TotalHours from "../../../../images/icons/total-hours-new.svg";
import { calculateTotalHours } from './Services/reportTimeWorked';

// Functional component
function TimeWorkedTotalHours({ trackReport }) {
  const [displayedHours, setDisplayedHours] = useState(0);
  const [targetHours, setTargetHours] = useState(0);
  const animationFrameRef = useRef(null);
  const reportingTimeWorked = useSelector((state) => state.reportingTimeWorked);

  useEffect(() => {
    if (trackReport && Array.isArray(trackReport) && reportingTimeWorked) {
      const totalTrackedHours = calculateTotalHours(trackReport, reportingTimeWorked);
      setTargetHours(totalTrackedHours || 0);
    } else {
      setTargetHours(0);
    }
  }, [trackReport, reportingTimeWorked]);

  useEffect(() => {
    // Cancel any existing animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    const startValue = displayedHours;
    const endValue = targetHours;
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * easeOut;
      setDisplayedHours(Math.floor(currentValue));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayedHours(endValue);
        animationFrameRef.current = null;
      }
    };

    if (Math.abs(startValue - endValue) > 0.01) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [targetHours]);

  const changeDurationFormat = (sec) => {
    // Ensure sec is a valid number
    const second = typeof sec === 'number' && !isNaN(sec) ? sec : 0;
    const hours = Math.floor(second / 3600);
    const minutes = Math.floor((second % 3600) / 60);
    const seconds = Math.floor(second % 60);
    const formattedDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    return formattedDuration;
  }
  return (
    <div>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">Total Hours</div>
          <div className="overview-icon">
            <img src={TotalHours} alt="cLock" />
          </div>
        </div>

        <div className="overview-rice">
          {changeDurationFormat(displayedHours)}
        </div>
      </div>
    </div>
  );
}

export default TimeWorkedTotalHours;
